module.exports = __webpack_public_path__ + "static/media/bg-recover.1f7ca6eb.jpg";